module.exports = __webpack_public_path__ + "static/images/solution.8935118cee034d5e716a2ecdf01338ac.png";